var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-container',[_c('v-row',{attrs:{"align":"center","no-gutters":""}},[_c('v-spacer',{staticClass:"hidden-sm-and-down"}),_c('v-col',{staticClass:"text-body-1",attrs:{"cols":"12","md":"auto"}},[_c('small',[_vm._v("Copyright (c) 2019 - "+_vm._s(_vm.currentYear)+", Picknote Inc.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }